// @flow
import * as React from 'react';
import { type ThemeType } from 'react-css-themr';
import { Link } from 'react-router-dom';
import { Tooltip, Icon } from '@locus-taxy/neo-ui';

import classnames from 'classnames';

type Props = {
    theme: ThemeType,
    active: boolean,
    testId: string,
    to: string,
    tooltip: React.Node,
    icon: string,
    disabled?: boolean
};

const LeftBarItem = ({
    active,
    theme,
    testId,
    to,
    tooltip,
    icon,
    disabled
}: Props): React.Node => {
    return (
        <Tooltip tooltip={tooltip} placement="right">
            <Link
                to={to}
                className={classnames(
                    { [theme.active]: active, [theme.disabled]: disabled },
                    theme.item
                )}
                testId={testId}
            >
                <Icon icon={icon} size="xLarge" />
            </Link>
        </Tooltip>
    );
};

export default LeftBarItem;
